// （FileLinkMan）
// （FileLinkTel）
// （FileEMail）
// （FileReceiveAddress）
// （BuyFromHome）
// （CompanyChargeName）
// （CompanyChargePhone）
// （CompanyChargeEmail）
// （DataUploadName）
// （DataUploadPhone）
// （DataUploadEmail）
// （DeliveryName）
// （DeliverPhone）
// （DeliveryAddress）
// （InvoiceName）
// （InvoicePhone）
// （InvoiceAddress）


const fromdata = [{
	inputdata: "",
	title: "文件联系人",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "文件联系电话",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "文件联系人邮箱",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "文件收件地址",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "是否从公司订货",
	fontSize: "14px",
	color: "#333333",
	placeholder: "",
	types: "text",
	inputtype: "radio",
	width: "210px",
	radio: "1",
	radiotitle1: "是",
	radiotitle2: "否",
	lablewith: "110px",
}, {
	inputdata: "",
	title: "业务负责人",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "140px",
}, {
	inputdata: "",
	title: "业务负责人电话",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "业务负责人邮箱",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "上报联系人",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "上报联系人电话",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "上报联系人邮箱",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "收货联系人",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "收货联系人电话",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "收货地址",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "发票联系人",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "发票联系电话",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}, {
	inputdata: "",
	title: "发票收件地址",
	fontSize: "14px",
	color: "#333333",
	placeholder: "请输入",
	types: "text",
	inputtype: "input",
	width: "210px",
	disabled: false,
	lablewith: "110px",
}];
export default fromdata;